import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import PolInfoBox from "v4/components/ui/PolInfoBox/PolInfoBox";
import ImportRowsInfosMapping
    from "v4/pages/admin/Import/components/ImportSteps/components/ImportRowsInfos/components/ImportRowsInfosMapping/ImportRowsInfosMapping";

export default function ImportRowsInfos({fullData, identifierFormMethods, form}) {
    const {t} = usePolTranslation();

    return (
        <div className="import-table__row-results__wrapper">
            {fullData?.totalItems !== undefined && (
                <PolInfoBox icon="affichage-ligne"
                            title={t('total_rows')}
                            text={fullData.totalItems}
                            isIconInfo/>
            )}
            {(fullData?.totalItems !== undefined && fullData?.totalNotValidatedItems !== undefined) && (
                <PolInfoBox icon="validation"
                            title={t('total_valid_rows')}
                            text={fullData.totalItems - fullData.totalNotValidatedItems}
                            isIconSuccess/>
            )}
            {fullData?.totalNotValidatedItems !== undefined && (
                <PolInfoBox icon="quit"
                            title={t('total_invalid_rows')}
                            text={fullData.totalNotValidatedItems}
                            isIconDanger/>
            )}
            {(fullData?.totalInsertItems !== undefined && fullData?.totalUpdatedItems !== undefined) && (
                <PolInfoBox icon="tasks"
                            className="rows-infos__total-insert-update"
                            isIconWarning>
                    <div className="pol-info-box__two-auto-columns">
                        <div>
                            <span className="pol-info-box__title">{t('added_rows')}</span>
                            <span className="pol-info-box__text">{fullData.totalInsertItems}</span>
                        </div>
                        <div>
                            <span className="pol-info-box__title">{t('edited_rows')}</span>
                            <span className="pol-info-box__text">{fullData.totalUpdatedItems}</span>
                        </div>
                    </div>
                </PolInfoBox>
            )}
            {identifierFormMethods && (
                <ImportRowsInfosMapping fullData={fullData} identifierFormMethods={identifierFormMethods} form={form}/>
            )}
        </div>
    )
}
